module.exports = __webpack_public_path__ + "assets/img/icon-search.b326f46d.png";